import React from "react";
import PropTypes from "prop-types";

import Modal from "components/Modal";
import Dialog from "components/Dialog";

export default class ModalDialog extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.node,
    fitScreen: PropTypes.bool
  }

  static defaultProps = {
    fitScreen: false
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} fitScreen={this.props.fitScreen}>
        <Dialog fitScreen={this.props.fitScreen}>
          { this.props.children }
        </Dialog>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/ModalDialog.js